<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="3">
              <v-text-field
                label="Nome da função"
                v-model="form.filters.nome"
                outlined
                dense
                @keyup.enter="buscarFuncoes"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                label="Tipo de perfil"
                :items="[
                  { label: 'Servidor do Estado de Pernambuco', value: 'true' },
                  { label: 'Profissional externo', value: 'false' },
                ]"
                :item-text="'label'"
                :item-value="'value'"
                v-model="form.filters.servidorDoEstado"
                outlined
                dense
                @keyup.enter="buscarFuncoes"
              ></v-select>
            </v-col>
            <sca-select-ativo
              :cols="3"
              :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
              v-model="form.filters.ativo"
              @enter="buscarFuncoes"
            ></sca-select-ativo>
          </v-row>
          <div class="text-center">
            <v-col cols="12">
              <sca-tooltip
                :text="'Buscar'"
                :icon="'mdi-magnify'"
                @click="buscarFuncoes()"
              ></sca-tooltip>
              <sca-tooltip
                :text="'Limpar'"
                :icon="'mdi-eraser'"
                @click="resetForm()"
              ></sca-tooltip>
              <sca-tooltip
                :text="'Incluir'"
                :icon="'mdi-plus'"
                @click="openDialogManterFuncao()"
              ></sca-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5"
          :headers="headers"
          :items="form.lists.listFuncoes"
          :items-per-page="10"
          :footer-props="$footerProps"
          no-data-text="Não há registros a serem exibidos"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.servidorDoEstado`]="{ item }">
            {{ item.servidorDoEstado ? "Servidor do Estado de Pernambuco" : "Profissional externo" }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
          </template>
          <template v-slot:[`item.acoes`]="{ item }">
            <sca-tooltip
              :text="'Visualizar'"
              :icon="'mdi-eye-outline'"
              :small="true"
              @click="openDialogVisualizarFuncao(item)"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Editar'"
              :icon="'mdi-pencil'"
              :small="true"
              @click="openDialogManterFuncao(item)"
            ></sca-tooltip>
            <sca-tooltip
              :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
              :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
              :small="true"
              @click="inativarAtivarFuncao(item)"
            ></sca-tooltip>
          </template>
        </v-data-table>
      </v-container>
      <CadastrarEditarFuncaoDialog
        :visible="dialogManterFuncao.visible"
        :content="dialogManterFuncao.content"
        :edit="dialogManterFuncao.edit"
        @onClose="dialogManterFuncao.close()"
        @onSave="buscarFuncoes()"
      ></CadastrarEditarFuncaoDialog>
      <VisualizarFuncaoDialog
        :visible="dialogVisualizarFuncao.visible"
        :content="dialogVisualizarFuncao.content"
        @onClose="dialogVisualizarFuncao.close()"
      ></VisualizarFuncaoDialog>
    </div>
  </template>

  <script>
  import { Dialog } from '~/commons/classes/dialog';
  import { Funcao } from '~/commons/classes/funcao';
  import FuncaoService from '~/services/funcao.service';
  import CadastrarEditarFuncaoDialog from "./dialogs/CadastrarEditarFuncaoDialog.vue";
  import VisualizarFuncaoDialog from "./dialogs/VisualizarFuncaoDialog.vue";

  export default {
    name: "ManterFuncoesView",
    mixins: [FuncaoService],
    components: {
      CadastrarEditarFuncaoDialog,
      VisualizarFuncaoDialog,
    },
    data: () => ({
      dialogManterFuncao: Dialog.Build(),
      dialogVisualizarFuncao: Dialog.Build(),
      form: {
        filters: {
          nome: null,
          ativo: null,
          servidorDoEstado: null,
        },
        lists: {
          listFuncoes: []
        }
      },
      headers: [
        { text: "Nome da função", align: "center", value: "nome" },
        { text: "Tipo de perfil", align: "center", value: "servidorDoEstado", sortable: false },
        { text: "Situação", align: "center", value: "situacao", sortable: false },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
      ]
    }),
    methods: {
      openDialogManterFuncao(funcao) {
        funcao
          ? this.$visualizarFuncoes(funcao).then(({ data }) => this.dialogManterFuncao.open(new Funcao(data.resposta.funcao), true))
          : this.dialogManterFuncao.open(Funcao.Build());
      },
      openDialogVisualizarFuncao(funcao) {
        this.$visualizarFuncoes(funcao).then(({ data }) => (this.dialogVisualizarFuncao.open(data.resposta.funcao)));
      },
      buscarFuncoes() {
        this.$buscarFuncoes({ params: this.form.filters }).then(({ data }) => (this.form.lists.listFuncoes = data.funcoes));
      },
      inativarAtivarFuncao(funcao) {
        this.$swal({
          text: `Deseja ${funcao.ativo ? "inativar" : "ativar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          this.$inativarAtivarFuncao(funcao.id).then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarFuncoes();
          });
        });
      },
      resetForm() {
        this.$resetForm();
        this.form.lists.listFuncoes = [];
        this.form.filters.ativo = null;
        this.buscarFuncoes();
      },
    }
  };
  </script>
